const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#F0F8FF',
    padding: '40px 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  content: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    maxWidth: '800px',
    width: '100%',
    border: '2px solid #09529f'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    borderBottom: '3px solid #09529f',
    paddingBottom: '15px'
  },
  headerTitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#09529f',
    margin: 0
  },
  backButton: {
    backgroundColor: '#09529f',
    color: '#ffffff',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  progressBar: {
    height: '8px',
    backgroundColor: '#e9ecef',
    borderRadius: '4px',
    marginBottom: '30px',
    overflow: 'hidden'
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#007bff',
    transition: 'width 0.3s ease'
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '30px',
    marginTop: 0,
    textAlign: 'center'
  },
  currentEmailDisplay: {
    backgroundColor: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '30px',
    textAlign: 'center'
  },
  sentEmailDisplay: {
    backgroundColor: '#e7f3ff',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '30px',
    textAlign: 'center',
    border: '2px solid #007bff'
  },
  currentEmail: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#666',
    margin: '5px 0 0 0'
  },
  sentEmail: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#007bff',
    margin: '5px 0 0 0'
  },
  formGroup: {
    marginBottom: '25px'
  },
  label: {
    display: 'block',
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '8px'
  },
  required: {
    color: '#dc3545',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #dee2e6',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box'
  },
  codeInput: {
    fontSize: '24px',
    letterSpacing: '8px',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  inputError: {
    borderColor: '#dc3545'
  },
  errorText: {
    color: '#dc3545',
    fontSize: '14px',
    marginTop: '8px',
    fontWeight: '500'
  },
  infoBox: {
    backgroundColor: '#e7f3ff',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '25px',
    border: '1px solid #b3d9ff'
  },
  infoText: {
    fontSize: '14px',
    color: '#004085',
    margin: 0,
    lineHeight: '1.6'
  },
  warningBox: {
    backgroundColor: '#fff3cd',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '25px',
    border: '1px solid #ffc107'
  },
  warningText: {
    fontSize: '14px',
    color: '#856404',
    margin: 0,
    lineHeight: '1.6'
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  button: {
    padding: '14px 24px',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    width: '100%'
  },
  primaryButton: {
    backgroundColor: '#007bff',
    color: '#ffffff'
  },
  secondaryButton: {
    backgroundColor: '#6c757d',
    color: '#ffffff'
  },
  tertiaryButton: {
    backgroundColor: '#ffffff',
    color: '#6c757d',
    border: '2px solid #6c757d'
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed'
  },
  successContainer: {
    textAlign: 'center'
  },
  successIcon: {
    width: '80px',
    height: '80px',
    backgroundColor: '#28a745',
    color: '#ffffff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    margin: '0 auto 20px',
    fontWeight: 'bold'
  },
  successTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '30px'
  },
  emailChangeInfo: {
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '25px'
  },
  emailChangeRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    margin: '10px 0'
  },
  emailChangeLabel: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '600'
  },
  emailChangeValue: {
    fontSize: '16px',
    color: '#333',
    fontWeight: '500'
  },
  emailChangeArrow: {
    fontSize: '24px',
    color: '#28a745',
    margin: '10px 0'
  }
};

export default styles;